import styled, {css, keyframes} from 'styled-components';

export const AgencyWrapper = styled.div(
  props => `
        width:100%;
    `,
);
export const KycPanWrapper = styled.div(
  props => `
        width:100%;
        display: flex;
        justify-content: space-between;
        align-itmes: center;
        padding-bottom:${props.theme.spacing.large.l15};

        @media only screen and (min-width:320px) and (max-width: 767px){
            flex-direction: column;
        }
    `,
);

export const PanBlockWrapper = styled.div(
  props => `
        width:49%;
        display: flex;

        @media only screen and (min-width:320px) and (max-width: 767px){
            width:100%;
        }
    `,
);

export const FacadeTextWrap = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    width:100%;
  `
)

export const FacadeDocText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const FacaceDocSubText = styled.p(
  props => `
    font-size: ${props.theme.font.small.s11};
    color: ${props.theme.colors.grey.base};
  `
)

export const KycLabelWrap = styled.div(
  props =>`
    width: 50%;
    display: flex;
    margin-left: ${props.theme.spacing.base};
    flex-direction: column;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      width: 100%;
      margin-left: 0;
    }
`);

export const GstOuterWrapper = styled.div(
  props => `
  width: 100%;
  padding-top: ${props.theme.spacing.large.l20};
  display: flex;
  flex-direction: column;
  opacity: ${props.disabled ? '0.2' : '1'};
  pointer-events: ${props.disabled ? 'none' : ''};
  display: ${props.disabled ? 'none' : 'flex'};
`);

export const GstInnerWrapper = styled.div(
  props => `
        width:100%;
        display: flex;
        padding-bottom:${props.theme.spacing.base};
        justify-content: space-between;
    `,
);

export const GstHeadTextWrap = styled.div(
  props => `
        width:50%;
        display: flex;
        justify-content: flex-start;
    `,
);

export const GstHeadText = styled.p(
  props => `
        font-size:${props.theme.font.large.font16};
        font-weight:${props.theme.font.fontWeight.bold};
        color: ${props.theme.colors.grey.base}

        @media only screen and (min-width:320px) and (max-width: 767px){
            font-size: ${props.theme.font.large.font14};
        }
    `,
);

export const GstDisabelWrap = styled.div(
  props => `
        width:50%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    `,
);

export const GstDisableText = styled.p(
  props => `
        font-size:${props.theme.font.large.font16};
        color: ${props.theme.colors.black.light5};

        @media only screen and (min-width:320px) and (max-width: 767px){
            font-size: ${props.theme.font.large.font14};
        }
    `,
);

export const StateCityWrapper = styled.div(
  props => `
        width:100%;
        display: flex;
        justify-content: space-around;

        @media only screen and (min-width:320px) and (max-width: 767px){
            flex-direction: column;
        }
    `,
);

const InputBlock = styled.input(
  props => `
    width: 95%;
    height: 4.2rem;
    cursor: pointer;
    border: 1px solid ${props.theme.colors.grey.lightd0};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.small};
    border-color: ${props.hasError ? props.theme.colors.red.base : ''}
    font-size: ${props.theme.font.large.font16};
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};

    ::placeholder {
      lin-height: ${props.theme.font.lineHeight.large};
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.grey.lightc5};
      overflow: visible;
    }
  `
)

export const InputState = styled(InputBlock)(
  props =>`
  width: 100%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-right: ${props.theme.spacing.nospacing};
    margin-bottom: ${props.theme.spacing.base};
  }
`);

export const InputCity = styled(InputBlock)(
  props => `
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      width: 100%;
      margin-right: ${props.theme.spacing.nospacing};
      margin-bottom: ${props.theme.spacing.base};
    }
`);

export const InputPincode = styled(InputBlock)(
  props =>`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    margin-bottom: ${props.theme.spacing.base};
  }
`);

export const GstSelect = styled.select(
  props =>`
  width: 100%;
  height: 4.2rem;
  background-color: ${props.theme.colors.white.base};
  display: flex;
  padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.base};
  border: 1px solid ${props.theme.colors.grey.lightd0};
  border-radius: ${props.theme.misc.borderRadius.small};
  border-color: ${props.hasError ? props.theme.colors.red.base : ''};

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: ${props.theme.spacing.base};
  }
`);

export const GstInCheckBox = styled.input.attrs({type: 'checkbox'})(
  props => `
    margin-right: ${props.theme.spacing.small.s5};
    margin-top: ${props.theme.spacing.small.s2};
    cursor: pointer;
  `,
);

export const FullDiv = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const InfoToolTip = styled.div(
  props =>`
  height: auto;
  max-width: 25rem;
  padding: 1rem;
  background-color: ${props.theme.colors.grey.dark3e};
  position: absolute;
  top: 100%;
  left: 3.5rem;
  z-index: ${props.theme.misc.zIndex.xxlarge};
  border-radius: ${props.theme.misc.borderRadius.base};
  color: ${props.theme.colors.white.base};
  font-size: ${props.theme.font.large.font14};
  box-shadow: 0px 0px 3px 0px ${props.theme.colors.black.light3};
  transition: all 0.25s ease-out;

  &:before {
    content: '';
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid ${props.theme.colors.grey.dark3e};
    top: -0.8rem;
    position: absolute;
  }
`);

export const InfoNoteText = styled.p(
  props => `
    margin-top:-1.2rem;
    font-size: ${props.theme.spacing.large.font12};
    color: ${props.theme.colors.black.base};
    margin-bottom: ${props.theme.spacing.large.l15};
  `
);

export const NoGstnMsg = styled.p(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.small.s5} 0;
    font-size: ${props.theme.spacing.large.font12};
    color: ${props.theme.colors.red.base};
  `
)
